import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { authApi } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams((location.hash || "").replace(/^#/, ""));
    const sid = params.get("session_id");
    (async () => {
      if (sid) {
        try {
          await authApi.session(sid);
        } catch {
          /* ignore, will land unauthenticated */
        }
      }
      window.history.replaceState({}, "", "/");
      await refresh();
      navigate("/", { replace: true });
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center text-lg font-semibold text-[#6e655b]">
      Signing you in…
    </div>
  );
}
